<template>
  <span>{{ formattedDate ? formattedDate : defShow }}</span>
</template>

<script setup>
import { computed } from 'vue';
import dayjs from 'dayjs';

const props = defineProps({
  modelValue: {
    type: Number,
    required: true,
  },
  format: {
    type: String,
    default: 'YYYY-MM-DD HH:mm:ss',
  },
  defShow:{
    type:String,
    default:'-'
  }
});


const formattedDate = computed(() => props.modelValue ? dayjs(props.modelValue).format(props.format):'');
</script>

<style scoped>
/* 样式可以根据需要进行调整 */
</style>
